// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__K7cd5","title":"AfterFrontImage_title__gq8E4"};